// StatusRibbon — vertical (90°-rotated) label spanning the full height of
// an event card, indicating its lifecycle status: LIVE / UPCOMING / FINISHED.
// SuspendedChip — inline marker for suspended events/markets (price grayed
// out next to it in the market lines).

import type { ReactNode } from 'react';

export type BoardStatus = 'live' | 'upcoming' | 'finished';

const RIBBON_CLASS: Record<BoardStatus, string> = {
  live: 'bg-red-500 text-white animate-pulse',
  upcoming: 'bg-sky-500 text-white',
  finished: 'bg-zinc-500 text-zinc-100',
};

export const ribbonLabel = (eventStatus: string): BoardStatus =>
  eventStatus === 'in_play'
    ? 'live'
    : eventStatus === 'closed' || eventStatus === 'settled'
      ? 'finished'
      : 'upcoming';

export function RibbonCard({
  status,
  children,
}: {
  status: BoardStatus;
  children: ReactNode;
}) {
  return (
    <div className="flex items-stretch gap-2">
      <span
        aria-label={`${status} event`}
        className={`flex w-6 shrink-0 items-center justify-center rounded-md text-[10px] font-bold uppercase tracking-[0.2em] ${RIBBON_CLASS[status]}`}
        style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}
      >
        {status}
      </span>
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}

export function SuspendedChip() {
  return (
    <span className="shrink-0 rounded bg-amber-500/15 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-400">
      suspended
    </span>
  );
}
